<template>
  <div v-if="visible" class="status-modal-backdrop" @click.self="$emit('close')">
    <div class="status-modal">
      <div class="status-modal__hero">
        <p class="section-kicker">{{ kicker }}</p>
        <h3>{{ title }}</h3>
        <p>{{ description }}</p>
      </div>

      <div class="status-modal__actions">
        <button
          type="button"
          class="status-modal__button status-modal__button--ghost"
          :disabled="loading"
          @click="$emit('close')"
        >
          {{ cancelText }}
        </button>
        <button
          type="button"
          class="status-modal__button"
          :class="confirmVariantClass"
          :disabled="loading"
          @click="$emit('confirm')"
        >
          <b-spinner v-if="loading" small />
          <span v-else>{{ confirmText }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrganizationActionModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    kicker: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    confirmText: {
      type: String,
      default: 'Confirm',
    },
    confirmVariant: {
      type: String,
      default: 'success',
      validator: (value) => ['danger', 'success'].includes(value),
    },
  },
  computed: {
    confirmVariantClass() {
      return this.confirmVariant === 'danger'
        ? 'status-modal__button--danger'
        : 'status-modal__button--success';
    },
  },
};
</script>

<style scoped>
.section-kicker {
  margin-bottom: 0.45rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #2c8d41;
}

.status-modal-backdrop {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(11, 25, 16, 0.48);
  backdrop-filter: blur(4px);
  z-index: 1100;
}

.status-modal {
  width: min(100%, 32rem);
  padding: 1.4rem;
  border: 1px solid rgba(28, 68, 38, 0.08);
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 28px 60px rgba(17, 41, 24, 0.2);
}

.status-modal__hero h3 {
  margin: 0 0 0.55rem;
  color: #183322;
}

.status-modal__hero p:last-child {
  margin: 0;
  color: #587063;
  line-height: 1.7;
}

.status-modal__actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
  margin-top: 1.35rem;
}

.status-modal__button {
  min-height: 3rem;
  border: 0;
  border-radius: 14px;
  font-weight: 700;
}

.status-modal__button--ghost {
  background: rgba(20, 38, 26, 0.06);
  color: #1f3826;
}

.status-modal__button--danger {
  background: #fff0f0;
  color: #bb4e4e;
}

.status-modal__button--success {
  background: linear-gradient(135deg, #16391f 0%, #30ab4c 100%);
  color: #fff;
}

@media (max-width: 991px) {
  .status-modal__actions {
    grid-template-columns: 1fr;
  }
}
</style>
